import React, { useEffect } from 'react'
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';

const RatingScale = ({ item, setItem, activeAccordion }) => {
  // Parse options from item.content (split by new lines)
  const { handleSelectSingleOption } = useNewItemChange(setItem, 'Viewer', activeAccordion);
  const options = item.options ? [...Array(Math.max(0, parseInt(item.options.split('-')[1]) - parseInt(item.options.split('-')[0]) + 1))].map((_, i) => ({
    content: i + parseInt(item.options.split('-')[0]),
    id: i
  })) : [];


  useEffect(() => {
    // if(item.selectedOptions) return
    const existingSelectedOptions = item.selectedOptions?.split(',') || [];
    const currentSelected = existingSelectedOptions.map(option => option.split('(D)')[0].trim());
    const optionsList = options.map(item => String(item.content));
    // Check if selected options are the same (considering the content and the '(D)' markers)
    if (JSON.stringify(currentSelected) === JSON.stringify(optionsList)) {
      return; // No change, so exit early
    }

    setItem(prev => {
      return prev.map(section => {
        if (section.key === activeAccordion) {
          const updatedItems = section.items.map(currItem => {
            if (currItem.ItemID === item.ItemID) {
              const list = options.map(item => item.content).join(",");
              return { ...currItem, selectedOptions: list };
            }
            return currItem;
          });
          return { ...section, items: updatedItems };
        }
        return section;
      });
    });
  }, [])

  const selectedOptions = item.selectedOptions?.split(',').length > 0 ?
    item.selectedOptions.split(',').map(checkBox => {
      checkBox = checkBox.split('(D)') || [];
      return ({
        content: checkBox[0],
        checked: checkBox.length > 1 ? true : false
      })
    }) : [];
  return (
    <div className='px-2 '>
      <p className='text font-m ar-light-color fs-13 pb-3px'>{item.content}</p>
      <div className="d-flex align-items-center gap-20 flex-wrap row-gap-8">
        {selectedOptions.length > 0 &&
          selectedOptions.map((option, index) => (
            <div className="ar_radio-btn d-flex align-items-center gap-6" key={index}>
              <input
                type="radio"
                id={`radio-${index}-${item.ItemID}`}
                checked={selectedOptions && selectedOptions[index]?.checked} // Use the options array to track checked status
                onChange={(e) => { e.stopPropagation(); handleSelectSingleOption(item, index) }} // Call function to toggle option  
              />
              <label className="text ar-orange-text" htmlFor={`radio-${index}-${item.ItemID}`}>{option.content}</label>
            </div>
          ))}
      </div>
    </div>
  );
};

export default RatingScale